export default "__VITE_ASSET__BEyU8OGe__"